<script setup>
import { onMounted, onUnmounted } from 'vue';

defineProps({
  maxWidth: String,
  maxHeight: String,
});

const emit = defineEmits(['close']);

const handleEscape = (event) => {
  const escCode = 27;
  const key = event.which || event.keyCode;

  if (key === escCode) {
    emit('close');
    event.stopPropagation();
  }
};

onMounted(() => document.addEventListener('keyup', handleEscape));

onUnmounted(() => document.removeEventListener('keyup', handleEscape));
</script>

<template>
  <div
    role="dialog"
    aria-modal="true"
    class="
      fixed
      z-50
      left-0
      top-0
      w-full
      h-full
      bg-[rgba(0,0,0,0.75)]
      overflow-y-auto"
    @click.self="emit('close')"
    @keyup.esc="emit('close')"
  >
    <div class="
      absolute
      left-[1rem]
      tablet:left-[5rem]
      top-[5rem]
      right-[1rem]
      tablet:right-[5rem]
      flex
      justify-center
      pb-[5rem]
      overflow-y-auto
    ">
      <slot name="content">
      </slot>
    </div>
  </div>
</template>
